module.exports = __webpack_public_path__ + "img/kaz.0da51fbe.svg";